import Vuex from 'vuex';
import Vue from 'vue';
import MobileDetect from 'mobile-detect';
import QuerystringManager from "./QuerystringManager";

Vue.use(Vuex);
const querystringManager = new QuerystringManager();

export default new Vuex.Store({
  state: () => ({
    sideAid: "", //Jursidiction/proposal (table_name, not proposal_id!! state needs to be rework to make sense)
    sideBid: "",
    sideAProposal: "",
    sideBProposal: "",
    sideADisplayName: "",
    sideBDisplayName: "",
    sideAColor: "",
    sideBColor: "",
    activeDistrictType: "",
    selectedDistrictSideA: "",
    selectedDistrictSideB: "",
    selectedLngLat: [],
    selectedState: "",
    buildType: "",
    mobile: false
  }),
  mutations: {
    resetSelection: function (state) {
      state.selectedLngLat = [];
      state.selectedDistrictSideA = "";
      state.selectedDistrictSideB = "";
      state.selectedState = "";
    },
    setSelectedState: function (state, val) {
      if (val !== state.selectedState) {
        state.selectedState = val;
        querystringManager.addQueryParam('state', val);
      }
    },
    setSideAid: function (state, val) {
      state.sideAid = val;
    },
    setSideBid: function (state, val) {
      state.sideBid = val;
    },
    setSideAProposal: function (state, val) {
      state.sideAProposal = val;
    },
    setSideBProposal: function (state, val) {
      state.sideBProposal = val;
    },
    setSideADisplayName: function (state, val) {
      state.sideADisplayName = val;
    },
    setSideBDisplayName: function (state, val) {
      state.sideBDisplayName = val;
    },
    setActiveDistrictType: function (state, val) {
      state.activeDistrictType = val;
    },
    setSelectedDistrictSideA: function (state, val) {
      state.selectedDistrictSideA = val;
    },
    setSelectedDistrictSideB: function (state, val) {
      state.selectedDistrictSideB = val;
    },
    setSelectedLngLat: function (state, val) {
      state.selectedLngLat = val;
    },
    setBuildType: function (state, val) {
      state.buildType = val;
    },
    setMobile: function (state) {
      let md = new MobileDetect(window.navigator.userAgent);
      if (md.mobile()) state.mobile = true;
      state.mobile = window.innerWidth < 800;
      // state.mobile = val;
    }
  },
  getters: {
    getSelectedState: function (state) {
      return state.selectedState;
    },
    getSideAid: function (state) {
      return state.sideAid;
    },
    getSideBid: function (state) {
      return state.sideBid;
    },
    getSideAProposal: function (state) {
      return state.sideAProposal;
    },
    getSideBProposal: function (state) {
      return state.sideBProposal;
    },
    getSideADisplayName: function (state) {
      return state.sideADisplayName;
    },
    getSideBDisplayName: function (state) {
      return state.sideBDisplayName;
    },
    getActiveDistrictType: function (state) {
      return state.activeDistrictType;
    },
    getSelectedDistrictSideA: function (state) {
      return state.selectedDistrictSideA;
    },
    getSelectedDistrictSideB: function (state) {
      return state.selectedDistrictSideB;
    },
    getSelectedLngLat: function (state) {
      return state.selectedLngLat;
    },
    getBuildType: function (state) {
      return state.buildType;
    },
    isMobile: function (state) {
      return state.mobile;
    }
  },
  modules: {}
});